import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import React__default, { useState, useRef } from 'react';
import classNames from 'classnames';
import filePickerStyles from './4e524b83c5fa4112390a83f1a4aec964c92fbcca0d819c1b9b7cc70d8acff55e.cfe-internal.js';
import buttonStyles from '../Button/91274a1d9a9d7c4d26f941102723fa0908c061d2e048fd7382d0966f9927d51a.cfe-internal.js';
import '../Button/dc121e2f212159f291e6ef8624b9668aa503817b9cff55ab585c7bb9b1925bf2.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import { useFormFieldContext } from '../FormField/f390dafefe74ba07f7da711a77443b7b51d96a6ad1aee47361fd1804064e9ba7.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';
import useId from '../../hooks/useId/df6d0ff48c086d34ec4e3589a05e8dd99a305947cee007fa9f94a6dd07ae8d17.cfe-internal.js';
import { useDidUpdate } from '../../hooks/useDidUpdate/f8ce5c85f293b5c4ca8be6bc5ac9f246003ac61cc91ab03b8814ccaab638a21a.cfe-internal.js';
import concatIds from '../../utils/concatIds/99a67648a55cf7a2ee84ef14be5ebb23af1b4b19b5520388cd5eef8f3f3a1e28.cfe-internal.js';
import { Button } from '../Button/f53b28c61b990709f9826a4237716d0d9d87dd41248bc45b1ed125999e0b4156.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';

var _excluded = ["className", "disabled", "files", "multiple", "onChange", "aria-label", "aria-labelledby", "aria-describedby", "id"];
var FileDetails = function FileDetails(_ref) {
  var files = _ref.files,
    id = _ref.id;
  if (files) {
    return /*#__PURE__*/React__default.createElement("span", {
      className: filePickerStyles.fileDetails,
      id: id
    }, _mapInstanceProperty(Array.prototype).call(files, function (file) {
      return /*#__PURE__*/React__default.createElement("span", {
        className: filePickerStyles.fileName,
        key: file.name
      }, file.name);
    }));
  }
  return null;
};
var FilePicker = /*#__PURE__*/React__default.forwardRef(function (_ref2, ref) {
  var _context, _context2, _context3, _context4;
  var className = _ref2.className,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    externalFiles = _ref2.files,
    _ref2$multiple = _ref2.multiple,
    multiple = _ref2$multiple === void 0 ? false : _ref2$multiple,
    onChange = _ref2.onChange,
    externalAriaLabel = _ref2['aria-label'],
    externalAriaLabelledBy = _ref2['aria-labelledby'],
    externalAriaDescribedBy = _ref2['aria-describedby'],
    externalId = _ref2.id,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInputFocused = _useState2[0],
    setIsInputFocused = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    filesChanged = _useState4[0],
    setFilesChanged = _useState4[1];
  var _useControllableState = useControllableState(undefined, undefined, externalFiles),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    files = _useControllableState2[0],
    setFiles = _useControllableState2[1];
  var fileInputId = useId(externalId);
  var fileDetailsId = "".concat(fileInputId, "-fileDetails");
  var buttonId = "".concat(fileInputId, "-button");
  var fileInputRef = useRef(null);
  var buttonRef = useRef(null);

  // TODO: Replace this with `useFormFieldControl` and add proper styling (this is a breaking change)
  var _useFormFieldContext = useFormFieldContext(),
    formFieldHelperTextId = _useFormFieldContext.helperTextId,
    formFieldErrorTextId = _useFormFieldContext.errorTextId;

  // returns focus to input after closing system dialog
  useDidUpdate(function () {
    var _fileInputRef$current;
    (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 || _fileInputRef$current.focus();
  }, [filesChanged]);
  var internalAriaDescribedby = concatIds(externalAriaDescribedBy, formFieldHelperTextId, formFieldErrorTextId);
  var handleChange = function handleChange(e) {
    setFiles(e.target.files, e);
    onChange === null || onChange === void 0 || onChange(e);
    // This is needed due to CFE-508
    setFilesChanged(function (val) {
      return !val;
    });
  };
  var messageKey = multiple ? 'filePicker.multiple' : 'filePicker.single';
  var buttonLabel = translate(messageKey);
  var fileNameLabel = files &&
  // eslint-disable-next-line compat/compat
  _trimInstanceProperty(_context = _mapInstanceProperty(_context2 = _Array$from(files)).call(_context2, function (file) {
    return file.name;
  }).join(' ')).call(_context);

  // `|| undefined` prevents an empty string from being added as the aria-label.
  var ariaLabel = _trimInstanceProperty(_context3 = [externalAriaLabel, fileNameLabel].join(' ')).call(_context3) || undefined;
  var ariaLabelledBy = _trimInstanceProperty(_context4 = [externalAriaLabelledBy, buttonId, ariaLabel ? fileInputId : undefined].join(' ')).call(_context4);
  return /*#__PURE__*/React__default.createElement("span", {
    className: classNames(className, filePickerStyles.container)
  }, /*#__PURE__*/React__default.createElement(Button, {
    disabled: disabled,
    kind: "secondary",
    onClick: function onClick() {
      var _fileInputRef$current2;
      return (_fileInputRef$current2 = fileInputRef.current) === null || _fileInputRef$current2 === void 0 ? void 0 : _fileInputRef$current2.click();
    },
    tabIndex: -1,
    className: classNames(_defineProperty({}, buttonStyles.keyboardFocused, isInputFocused)),
    ref: buttonRef,
    onFocus: function onFocus() {
      var _fileInputRef$current3;
      return (_fileInputRef$current3 = fileInputRef.current) === null || _fileInputRef$current3 === void 0 ? void 0 : _fileInputRef$current3.focus();
    },
    id: buttonId,
    "aria-hidden": true
  }, buttonLabel), /*#__PURE__*/React__default.createElement("input", _extends({}, rest, {
    key: String(filesChanged),
    className: filePickerStyles.fileInput,
    disabled: disabled,
    multiple: multiple,
    onChange: disabled ? undefined : handleChange,
    ref: mergeRefs(fileInputRef, ref),
    type: "file",
    onFocus: function onFocus() {
      return setIsInputFocused(true);
    },
    onBlur: function onBlur() {
      return setIsInputFocused(false);
    },
    "aria-label": ariaLabel,
    id: fileInputId,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": internalAriaDescribedby
  })), /*#__PURE__*/React__default.createElement(FileDetails, {
    id: fileDetailsId,
    files: files
  }));
});

export { FilePicker as default };
